<template>
  <div class="container">
    <PublicHeader :totalName="$t('share').title" />
    <!-- 佣金 -->
    <div class="commissionInfo">
      <div class="txt">{{ $t('share').commission }}</div>
      <div class="num">${{ userInfo.commissionAmount.toFixed(2).replace(/\.?0+$/, '') }}</div>
    </div>
    <div class="line"></div>
    <div class="content">
      <!-- 佣金记录 -->
      <div class="item" @click="$router.push({ name: 'CommissionList' })">
        <div class="left">
          <span>{{ $t('share').Commissionrecord }} </span>
        </div>
        <div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
      <!-- 佣金转出 -->
      <div class="item" @click="$router.push({ name: 'RollOut' })">
        <div class="left">
          <span>{{ $t('share').Commissiontransferout }}</span>
        </div>
        <div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
      <!-- 转出记录 -->
      <div class="item" @click="$router.push({ name: 'RollOutList' })">
        <div class="left">
          <span>{{ $t('share').Transferoutrecord }}</span>
        </div>
        <div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
      <!-- 邀请好友 -->
      <div class="item" @click="$router.push({ name: 'Invite' })">
        <div class="left">
          <span>{{ $t('share').Invitefriends }}</span>
        </div>
        <div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
      <!-- 邀请记录 -->
      <div class="item" @click="$router.push({ name: 'InviteList' })">
        <div class="left">
          <span>{{ $t('share').Invitationrecord }}</span>
        </div>
        <div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import { mapGetters } from 'vuex'
import PublicHeader from '@/components/publicHeader'

export default {
  components: {
    PublicHeader,
  },
  data() {
    return {
      userInfo: { commissionAmount: 0 },
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    this.getMemberInfo()
  },
  methods: {
    // 获取用户信息
    async getMemberInfo() {
      const res = await userApi.getMemberInfo()
      this.userInfo = res.user
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);

  .commissionInfo {
    padding: 65px 15px 20px 15px;

    .txt {
      font-size: 13px;
      color: var(--text_color);
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .num {
      margin-top: 10px;
      font-weight: bold;
      font-size: 24px;
      color: var(--text_color);
    }
  }

  .line {
    height: 7px;
    background: var(--info_color);
  }

  .content {
    .item {
      padding: 20px 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;
        align-items: center;

        span {
          font-size: 15px;
          color: var(--text_color);
        }
      }

      span {
        font-size: 13px;
        color: var(--ntext_color);
        margin-right: 10px;
      }
    }
  }
}
</style>
